// extracted by mini-css-extract-plugin
module.exports = {"Row":"Vinculo_Row__2DBQM","LogoPlataforma":"Vinculo_LogoPlataforma__2tr3-"};